/**
 * Performance chart time resolution options
 */
export enum PerformanceChartResolution {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  THREE_MONTHS = "THREE_MONTHS",
  SIX_MONTHS = "SIX_MONTHS",
  YEAR = "YEAR",
  ALL = "ALL",
}

/**
 * Performance return calculation methodologies.
 *
 * TWR (Time-Weighted Return) is the existing strategy-performance view. It
 * isolates portfolio/strategy performance by neutralizing external cash flows,
 * so deposits and withdrawals do not by themselves move the reported return.
 *
 * MWR (Money-Weighted Return) is the user money-outcome view. It reflects the
 * actual dollars the user put in and took out:
 *
 *   Net PnL = current value + withdrawals - deposits
 *   Return % = Net PnL / (deposits - withdrawals)
 *
 * Callers must choose one explicitly. Avoid defaults here so endpoint, service,
 * and UI code cannot accidentally mix strategy-only performance with the
 * retail-brokerage style money outcome.
 */
export enum PerformanceReturnMethod {
  /** Time-weighted return: strategy performance with cash flows neutralized. */
  TWR = "TWR",
  /** Money-weighted return: actual user outcome including deposits/withdrawals. */
  MWR = "MWR",
}
